var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('dashboard'),
        path: '/dashboard',
        icon: 'fas fa-chart-line text-blue',
      }}}),(_vm.rol == 'admin')?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('ingresos'),
        path: '/ingresos',
        icon: 'ni ni-delivery-fast text-blue'
      }}},[_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('todos'),
          path: '/ingresos',
          icon: 'ni ni-money-coins text-blue'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('incompletos'),
          path: '/ingresos/incompletos/1',
          icon: 'ni ni-money-coins text-blue'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('pendientes'),
          path: '/ingresos/pendientes/2',
          icon: 'ni ni-money-coins text-blue'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('completos'),
          path: '/ingresos/completados/3',
          icon: 'ni ni-money-coins text-blue'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('pagados'),
          path: '/ingresos/pagados/4',
          icon: 'ni ni-money-coins text-blue'
        }}})],1):_vm._e(),(_vm.rol == 'admin')?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('egresos'),
        path: '/egresos',
        icon: 'ni ni-delivery-fast text-blue icon-mirror'
      }}},[_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('todos'),
          path: '/egresos',
          icon: 'ni ni-money-coins text-blue'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('incompletos'),
          path: '/egresos/incompletos/1',
          icon: 'ni ni-money-coins text-blue'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('pendientes'),
          path: '/egresos/pendientes/2',
          icon: 'ni ni-money-coins text-blue'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('completos'),
          path: '/egresos/completados/3',
          icon: 'ni ni-money-coins text-blue'
        }}}),_c('sidebar-item',{attrs:{"link":{
          name: _vm.$t('pagados'),
          path: '/egresos/pagados/4',
          icon: 'ni ni-money-coins text-blue'
        }}})],1):_vm._e(),(_vm.rol == 'admin')?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('estado_pagos'),
        path: '/pagos',
        icon: 'ni ni-single-copy-04 text-blue'
      }}}):_vm._e(),(_vm.rol == 'admin')?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('empresas'),
        path: '/empresas',
        icon: 'fa fa-building text-blue'
      }}}):_vm._e(),(_vm.rol == 'admin')?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('usuarios'),
        path: '/usuarios',
        icon: 'ni ni-single-02 text-blue'
      }}}):_vm._e(),(_vm.rol == 'admin')?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('choferes'),
        path: '/choferes',
        icon: 'ni ni-bus-front-12 text-blue'
      }}}):_vm._e(),(_vm.rol == 'admin')?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('materiales'),
        path: '/materiales',
        icon: 'ni ni-settings-gear-65 text-blue'
      }}}):_vm._e(),(_vm.rol == 'admin')?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('plantas'),
        path: '/plantas',
        icon: 'fa fa-industry text-blue'
      }}}):_vm._e(),(_vm.rol == 'admin')?_c('sidebar-item',{attrs:{"link":{
        name: _vm.$t('folios'),
        path: '/folios',
        icon: 'fa fa-file-alt text-blue'
      }}}):_vm._e(),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":_vm.materialesUrl}},[_c('i',{staticClass:"fas fa-boxes text-blue"}),_c('span',{staticClass:"nav-link-text"},[_vm._v(_vm._s(_vm.$t('portal_materiales')))])])])],1)],2),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }